import React, { createContext, useContext, useState } from "react";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [colorTheme, setColorTheme] = useState(null);
  const [countryProperties,setCountryProperties] = useState({})
  const [logoUrl, setLogoUrl] = useState(null);
  const [whiteLabelName, setWhiteLabelName] = useState(null);
  const [canReserve, setCanReserve] = useState(false);

  return (
    <ThemeContext.Provider
      value={{
        colorTheme,
        logoUrl,
        whiteLabelName,
        setColorTheme,
        setLogoUrl,
        setWhiteLabelName,
        canReserve,
        setCanReserve,
        countryProperties,
        setCountryProperties
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
